import React, { Component, createRef } from 'react'
import Axios from 'axios';
import qs from 'qs';
import { Input, Modal, Select, Button, Radio, Form, Checkbox, DatePickerProps, DatePicker, Tooltip, AutoComplete, notification } from 'antd';
import $ from 'jquery';
import { Link } from "react-router-dom";
import AsideLeft from '../../components/aside/asideleft';
import {
    PATIENT_DATA,
    Get_Obs_Gyane_Data,
    Save_Obs_Gyane_Data,
    VaccinationList,
    LAB_AND_RADIOLOGY_TESTS,
    RISK_FACTORS_LIST,
    OBJECTIVE_GETALL,
    DURATION_TYPE,
    INFORMED_BY,
    MEDICATION_ON,
    FETAL_MOVEMENT,
    PRESENTATION,
    RELATIONSHIP_TO_PP_BRIM,
    LOADER,
    CONCEPTION_OPTIONS,
    PREGNANCY_OPTIONS,
    DELIVERY_OPTIONS,
    OUTCOME_OPTIONS,
    PLACE_OF_DELIVERY_OPTIONS,
    ISALLOWEDITSOAP,
    Save_Anc_Details,
    Get_Anc_Details,
    Get_Anc_Previous_Details,
    Print_Anc_Details,

} from "../../utils/constant";
import { lmpDataService, gpaleDataService, lactatingService, speechService, speechTextService } from '../../utils/rxjs-sharing';
import MyHcSpeechRecognition from "../../pages/speech-to-text/speech-recognition";
import LS_SERVICE from "../../utils/localStorage";
import { headerService$ } from '../../utils/rxjs-sharing';
import moment from "moment";
import BasicComponent from './basic';
import { Container } from 'react-bootstrap';
import { ArgumentNullError } from 'microsoft-cognitiveservices-speech-sdk/distrib/lib/src/common/Error';
import MultiplePregnancies from './sscomponents/MultiplePregnancies';
import AncCardView from '../patient-detail/anccardview';
const { Option } = Select;

export default class AncCard extends Component {
    constructor(props) {
        super(props);
        this.ancFormRef = React.createRef();
        this.state = {
        	patientInfo: null,
        	patient_id: null,
        	reference_id: null,
        	reference_type: null,
        	doctor_id: null,
        	current_allergies : [],
        	current_conditions : [],
        	risk_factors_options: [],
        	pregnancy_risk_factor : [],
      		pregnancy_risk_factor_selected: [],
      		pregnancy_risk_factor_management_remarks : null,
        	vaccineData : [],
        	labTestData : [],
        	radiologyTestData: [],
        	currentPregnancyData : null,
        	speech: {
                identifier: null,
                state: false
            },
            gender_options: [
                { val: '1', label: 'Male' },
                { val: '2', label: 'Female' },
                { val: '3', label: 'Transgender' }
            ],
            immuno_remarks : null,
            conception_options: CONCEPTION_OPTIONS,
            pregnancy_options: PREGNANCY_OPTIONS,
            delivery_options: DELIVERY_OPTIONS,
            outcome_options: OUTCOME_OPTIONS,
            place_of_delivery_options: PLACE_OF_DELIVERY_OPTIONS,
            pregnancy_year : null,
            year_options: [],
            delivery_mode : null,
            pregnancy_type : null,
            delivery_type : null,
            delivery_place : null,
            delivery_outcome : null,
            delivery_bith_date_time : null,
            delivery_gender : null,
            delivery_birth_weight : null,
            delivery_birth_height : null,
            delivery_birth_head_cc : null,
            delivery_congenital_abnormality : false,
            delivery_congenital_abnormality_remarks : null,
            delivery_indication_for_c_section : null,
            delivery_details : null,
            multiple_pregnancies : [],
            MultipleSavedPregnancies: [],
            print_only_populated_fields : false,
            allowEdit:false,
            multiplePregnanciesModal: false,
            prevAncCardData : [],
            showRxModal: false,
    		rxPdfPath: null,
    		isPrintLoader: false,
    		spin_loading : false,
        }
    }

    componentDidMount = async () => {
    	const { match: { params } } = this.props;
    	await this.setState({
    		patient_id: params.patient_id,
            reference_id: params.reference_id,
            reference_type: params.reference_type,
            doctor_id: (LS_SERVICE.get('user_type') === 2) ? LS_SERVICE.get('selectedDoctorIdAppoinement') : LS_SERVICE.get('staff_id')
    	});
    	let hospitalConfigData = LS_SERVICE.get('hospitalConfigData')??[];
        hospitalConfigData = hospitalConfigData.find(item=>item.hospital_id==params.hospital_id);

        let allowEdit = hospitalConfigData?ISALLOWEDITSOAP(hospitalConfigData.pres_modification, hospitalConfigData.allow_hours, LS_SERVICE.get('appointmentCompletedTime')[params.reference_id], 'button'):true;

        this.setState({
            allowEdit,
        }, async () => {
            if (LS_SERVICE.has('hospitalConfigData')) {
                const hospitalConfigData = LS_SERVICE.get('hospitalConfigData');
                let hospitalConfigObj = hospitalConfigData.find(obj => obj.hospital_id == params.hospital_id);
                headerService$.soapConfig({ soapConfig: hospitalConfigObj.opd_layout }); // IMPORTANT TO HIT AS PER THE VIEW
            }
        });
    	let cyear = new Date().getFullYear();
        let syear = cyear - 20;
        let year_options = [];

        for (let i = cyear; i >= syear; i--) {
            year_options.push(i);
        }
        this.setState({
            year_options
        });
    	const ss_configuration = LS_SERVICE.get('ss_configuration');
	    const patient_full_data = LS_SERVICE.get('call_patient_detail');
	    await this.setState({
	        ss_configuration: ss_configuration,
	        consult_type: patient_full_data?.consult_type == 1 ? 'vc' : 'opd'
	    })
    	this.subscription = speechTextService.status().subscribe((data) => {
            if (this.state.speech.state) {
                if (this.state.speech.identifier === "pregnancy_risk_factor_management_remarks") {
                    this.ancFormRef.current.setFieldsValue({ pregnancy_risk_factor_management_remarks: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }
                if (this.state.speech.identifier === "delivery_details") {
                    this.ancFormRef.current.setFieldsValue({ delivery_details: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                if (this.state.speech.identifier === "delivery_indication_for_c_section") {
                    this.ancFormRef.current.setFieldsValue({ delivery_indication_for_c_section: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                if (this.state.speech.identifier === "immuno_remarks") {
                    this.ancFormRef.current.setFieldsValue({ immuno_remarks: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                if (this.state.speech.identifier === "delivery_congenital_abnormality_remarks") {
                    this.ancFormRef.current.setFieldsValue({ delivery_congenital_abnormality_remarks: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                // else {
                //     this.state.savetests.map((obj, index) => {
                //         if (this.state.speech.identifier === `result${index}` ? `result${index}` : '') {
                //             let test_result = [`result${index}`];
                //             //this.setState({ [test_result]: data.text });
                //             this.ancFormRef.current.setFieldsValue({ [test_result]: data.text });
                //         }
                //     });
                // }

            }
        });
        await this.optionRiskFactorsList();
        await this.getPatientData();
        await this.getPatientObsGyaneData();
        await this.handleObjectiveGetAllData();
        // await this.getAncTestData();
        await this.getPatientAncDetails();
        await this.getPatientAncPreviousDetails();        
    }

    printAncDetails = async () => {
        await this.onFinishAncForm("print");
	    const BODY = {
	    	patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
			reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
			reference_type: 0,
			hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
			enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
			source: 'OP',
	    }
	    await this.setState({ isPrintLoader : true });
	    await Axios.post(Print_Anc_Details, BODY).then(async (response) => {
			if(response.data.status == true)
			{
				await this.setState({ rxPdfPath: response.data.pdf_url, showRxModal: true, });

			} else {
				notification.error({
	                message: "Oops! Something snapped. Please try again.",
	                placement: "topRight",
	            });
			}
	    	await this.setState({ isPrintLoader : false });
	    }).catch(async (err) => {
			notification.error({
                message: "Oops! Something snapped. Please try again.",
                placement: "topRight",
            });
            await this.setState({ isPrintLoader : false });
	    });
    
  	}

    onFinishAncForm = async (submit_type = null) => {
        if(submit_type != "print")
        {
          await this.setState({ spin_loading : true });
        }
    	let anc_details = {
			patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
			reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
			reference_type: 0,
			hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
			enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
			source: 'OP',
			current_allergies : this.state.current_allergies ? JSON.stringify(this.state.current_allergies) : null,
			current_conditions : this.state.current_conditions ? JSON.stringify(this.state.current_conditions) : null,
			vaccine_data : this.state.vaccineData ? JSON.stringify(this.state.vaccineData) : null,
			immuno_remarks : this.state.immuno_remarks,
			pregnancy_year : this.state.pregnancy_year || null,
			delivery_mode : this.state.delivery_mode || null,
			pregnancy_type : this.state.pregnancy_type || null,
			delivery_indication_for_c_section : this.state.delivery_indication_for_c_section || null,
			delivery_details : this.state.delivery_details || null,
			created_by : LS_SERVICE.get('staff_id'),
			updated_by : LS_SERVICE.get('staff_id')
	    }
	    if(this.state.pregnancy_type != "2")
	    {
	    	anc_details.delivery_type = this.state.delivery_type || null;
			anc_details.delivery_place = this.state.delivery_place || null;
			anc_details.delivery_outcome = this.state.delivery_outcome || null;
			anc_details.delivery_gender = this.state.delivery_gender || null;
			anc_details.delivery_bith_date_time = this.state.delivery_bith_date_time != null ? moment(this.state.delivery_bith_date_time).format('YYYY-MM-DD HH:mm:ss') : null;
			anc_details.delivery_birth_weight = this.state.delivery_birth_weight || null;
			anc_details.delivery_birth_height = this.state.delivery_birth_height || null;
			anc_details.delivery_birth_head_cc = this.state.delivery_birth_head_cc || null;
			anc_details.delivery_congenital_abnormality = this.state.delivery_congenital_abnormality ? 'true' : 'false';
			anc_details.delivery_congenital_abnormality_remarks = this.state.delivery_congenital_abnormality_remarks || null;
	    }
	    else
	    {
	    	anc_details.multiple_pregnancies = this.state.multiple_pregnancies;
	    }
	    let where_condition = {
			patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
			reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
			reference_type: 0,
			hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
			enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
			source: 'OP',
	    }

	    let Params = {
			where_condition,
			anc_details,
	    };
	    // console.log(this.state.vaccineData);
	    // console.log(Params);

	    // return false;
	    await Axios.post(Save_Anc_Details,Params).then(async res => {
	    	if(submit_type != "print")
            {
                notification.success({
                  message: "Anc card saved successfully",
                  placement: "topRight",
                });
                await this.setState({ spin_loading : false });
            }
            await this.handleSaveObsGyaneData();
	    })
	    .catch(async (error) => {
			notification.error({
				message: 'Something went wrong! Unable to save the data',
				placement: 'topRight'
			})
    		await this.setState({ spin_loading : false });
	    });
    }

    handleSaveObsGyaneData = async () => {
	    let obs_gyane_data = {
	      pregnancy_risk_factor : this.state.pregnancy_risk_factor.length > 0 ? this.state.pregnancy_risk_factor.toString(): null,
	      pregnancy_risk_factor_management_remarks : this.state.pregnancy_risk_factor_management_remarks,
	      updated_by : LS_SERVICE.get('staff_id')
	    }
	    let where_condition = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      reference_type: 0,
	      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      source: 'OP',
	    }

	    let Params = {
	      where_condition,
	      obs_gyane_data,
	    }
	    await Axios.post(Save_Obs_Gyane_Data,Params).then(async res => {
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to save the data',
	        placement: 'topRight'
	      })
	    })
  	}

    disabledPastDate(current) {
        return current && (current > moment());
    }

    handleObjectiveGetAllData = async () => {
        const { patient_id } = this.state;
        const objectiveGetAllPromise = await Axios.get(OBJECTIVE_GETALL({ patient_id }));

        if (objectiveGetAllPromise.data.status) {
            const { data } = objectiveGetAllPromise.data;
            const { details, constants } = data;
            const { allergies, conditions } = details;
            await this.setState({
                current_allergies : allergies.patientAllergies,
                current_conditions : conditions.patientConditions,
            });
        }
    };

    optionRiskFactorsList() {
        Axios.get(RISK_FACTORS_LIST).then(async success => {
            if (success?.data?.status == true) {
                this.setState({ risk_factors_options: success.data.data });
            }
        }).catch(err => console.log(err));
    }

    optionRiskFactorsLoad() {
        if (!this.state.risk_factors_options || this.state.risk_factors_options.length === 0) {
            return (<Option value={0}><span>No Result Found</span></Option>)
        }
        return this.state.risk_factors_options.map((obj, i) => {
            return (<Option key={i} value={parseInt(obj.id)} title={obj.description}>{obj.description}</Option>)
        }, this)
    }

    validateNumber = (rule, value, callback) => {
        const isValidInput = /^(\d{1,2}(\.\d{0,2})?)?$/.test(value) && parseFloat(value) <= 100;

        if (isValidInput || value === '') {
            callback();
        } else {
            callback('Only allowed (maximum 100 and upto two decimals).');
        }
    };

    normalizeValue = (value) => {        
      return value === "" || value === undefined ? "" : +value
    }

    getVaccineData() {
        let totalvaccine_data = []
        let params = { anc: 'active' };
        Axios.post(VaccinationList, params)
        .then((success) => {
            let totalvaccine = success.data.data;
            let alredyAddedVaccine = [];
            totalvaccine?.map(ele => {
                if (ele.anc == "Y" && !alredyAddedVaccine.includes(ele.vaccinationId)) {
                    let i;
                    for (i = 1; i <= ele.noOfDoses; i++) {
                        totalvaccine_data.push({
                            active: ele.active,
                            anc: ele.anc,
                            name: ele.name + " " + i,
                            noOfDoses: ele.noOfDoses,
                            type: ele.type,
                            vaccinationId: ele.vaccinationId,
                            // vaccine_list: ele.vaccine_list,
                            vaccine_status : "false",
                            vaccine_date : null
                            // dose_number: i + 1,
                        });
                    }
                    alredyAddedVaccine.push(ele.vaccinationId)
                }                
            });
            this.setState({ vaccineData: totalvaccine_data });
        });
    }

    getAncTestData() {
        let test_data = [];
        let radiologytest = [];
        let {facilityID, enterpriseId} = this.state;
        let params = { 
            facilityId : facilityID,
            enterpriseId: enterpriseId 
        };
        Axios.post(LAB_AND_RADIOLOGY_TESTS, params)
        .then((response) => {
            let tests = response.data.test_list;
            tests?.map(obj => {
                if (obj.type == "Lab") {
                    test_data.push(obj)
                }
                else {
                    radiologytest.push(obj)
                }
            })
            this.setState({ labTestData: test_data, radiologyTestData: radiologytest });
        });
    }

    handleModalPopup = async (e, popup) => {
        if (e !== null) e.preventDefault();
        this.setState({
            [popup]: !this.state[popup],
        });
    }

    handleModalSave = async (obj) => {
        if (obj?.multiple_pregnancies != undefined) {
            await this.setState({
                multiple_pregnancies: obj.multiple_pregnancies
            });
        }
        else
        {
        	await this.setState({
                multiple_pregnancies: []
            });
        }
        await this.setState({
            multiplePregnanciesModal: false,
        });

        // console.log(this.state.multiple_pregnancies)
    }

    getPatientData = async () => {
        const { patient_id } = this.state;
        Axios.get(PATIENT_DATA({ patient_id }))
        .then(async (success) => {
            const patientInfo = {
                ...success.data.data.results,
                qms_token_id: success.data.data.results.qmsToken
                    ? success.data.data.results.qmsToken.qms_token_id
                    : null,
            };
            await this.setState({
                patientInfo,
            });
        })
        .catch((err) => console.log(err));
    }

    componentWillUnmount() {
        this?.subscription?.unsubscribe();
    }

    //Speech
    initSpeech(info) {
        let initialText = '';
        if (info.identifier === 'pregnancy_risk_factor_management_remarks') {
            initialText = this.state.pregnancy_risk_factor_management_remarks != undefined ? this.state.pregnancy_risk_factor_management_remarks : '';
        }
        if (info.identifier === 'delivery_details') {
            initialText = this.state.delivery_details != undefined ? this.state.delivery_details : '';
        }
        if (info.identifier === 'delivery_indication_for_c_section') {
            initialText = this.state.delivery_indication_for_c_section != undefined ? this.state.delivery_indication_for_c_section : '';
        }

        if (info.identifier === 'delivery_congenital_abnormality_remarks') {
            initialText = this.state.delivery_congenital_abnormality_remarks != undefined ? this.state.delivery_congenital_abnormality_remarks : '';
        }

        if (info.identifier === 'immuno_remarks') {
            initialText = this.state.immuno_remarks != undefined ? this.state.immuno_remarks : '';
        }

        if (info.identifier === this.state.speech.identifier) {
            this.setState({
                speech: {
                    identifier: info.identifier,
                    state: !this.state.speech.state,
                    initialText: initialText
                }
            }, () => {
                speechService.init(this.state.speech);
            });
        }
        else {
            this.setState({
                speech: {
                    identifier: this.state.speech.identifier,
                    state: false,
                    initialText: ''
                }
            }, () => {
                speechService.init(this.state.speech);
                setTimeout(() => {
                    this.setState({
                        speech: {
                            identifier: info.identifier,
                            state: true,
                            initialText: initialText
                        }
                    }, () => {
                        speechService.init(this.state.speech);
                    });

                }, 1000);
            });
        }
    }

    onSelectChangeList = async (value, props, field) => {
        await this.setState({
            [field]: value
        });
        if (field == 'pregnancy_type' && (value == '1' || value == '3')) {
            this.setState({
                multiple_pregnancies: []
            });
        }
        if (field == 'pregnancy_type' && value == '2') {
            this.setState({
                multiplePregnanciesModal: true
            });
        }
    }

    onSelectCheckChangeListMultiple = async (e) => {
        await this.setState({
            delivery_congenital_abnormality: e.target.checked
        })

        await this.ancFormRef.current.setFieldsValue({
        	delivery_congenital_abnormality : e.target.checked
        })

        if(e.target.checked == false)
        {
        	await this.setState({
	            delivery_congenital_abnormality_remarks: null
	        })

	        await this.ancFormRef.current.setFieldsValue({
	        	delivery_congenital_abnormality_remarks : null
	        })
        }
    }

    getPatientAge(dob) {
        var ageD = Math.floor(moment().diff(moment(dob, 'YYYY-MM-DD'), 'D') / (1000 * 3600 * 24));
        var ageM = moment().diff(moment(dob, 'YYYY-MM-DD'), 'M');
        var ageY = ageM / 12;
        var remainM = ageM % 12;
        ageY = Math.floor(ageY);
        var ageText = '';
        if (ageM == 0)
            ageText = ageD + ' Day' + (ageD == 1 ? '' : 's');
        else if (ageY < 1)
            ageText = ageM + ' Mon' + (ageM == 1 ? '' : 's');
        else if (ageY <= 5) {
            if (remainM != 0) {
                ageText = ageY + ' Yr' + (ageY == 1 ? '' : 's ') + remainM + ' Mon' + (remainM == 1 ? '' : 's');
            } else {
                ageText = ageY + ' Yr' + (ageY == 1 ? '' : 's');
            }
        }
        else
        ageText = ageY + ' Years' + (remainM != 0 ? ' ' + remainM + ' Month' + (remainM === 1 ? '' : 's') : '');
        return ageText;
    }

    handleOnPregnancyRiskFactorChange = async (val,props) => {
	    let pregnancy_risk_factor_selected_data = [];
	    await this.setState({
	      pregnancy_risk_factor_selected: val,
	      obs_gyane_change_detected : true
	    });
	    props.forEach(element => {
	      pregnancy_risk_factor_selected_data.push(element.value);
	    });

	    await this.setState({
	      pregnancy_risk_factor: pregnancy_risk_factor_selected_data.join(),
	      obs_gyane_change_detected: true
	    });
	}

    autoHeight = (e) => {
	    if (e)
	    {
	    	e.target.style.height = e.target.scrollHeight + "px";
	    }	
    }  

    handleOnTextChange = async(event) => {
	    const { name, value } = event.currentTarget;
	    await this.setState({
	      [name]: value
	    });
	    await this.ancFormRef.current.setFieldsValue({
	      [name]: value
	    });
  	}

    onCheckVaccine = async (event, index, field) => {
        const checked = event.target.checked;
    	const value = checked ? "true" : "false";
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index][field] = value;
	      return { vaccineData: prevItems };
	    });

	    if(value == "false")
	    {
	    	await this.setState(prevState => {
		      const prevItems = [...prevState.vaccineData];
		      prevItems[index]['vaccine_date'] = null;
		      return { vaccineData: prevItems };
		    });
	    }

	    // console.log(this.state.vaccineData)
    }

    handleVaccineDate = async (date, dateString, index, field) => {
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index][field] = moment(date).format("YYYY-MM-DD");
	      prevItems[index]['vaccine_status'] = "true";
	      return { vaccineData: prevItems };
	    });

	    // console.log(this.state.vaccineData);
  	}

    getPatientObsGyaneData = async () => {
	    let Params = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      reference_type: 0,
	      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      source: 'OP',
	    }
	    await Axios.post(Get_Obs_Gyane_Data,Params).then(async res => {
			if(res.data.status == true)
			{
				await this.setState({
					currentPregnancyData : res.data.data
				});

				if(this.state.currentPregnancyData)
				{
					if(this.state.currentPregnancyData?.pregnancy_risk_factor != null && this.state.currentPregnancyData?.pregnancy_risk_factor != null != "")
					{
						let pregnancy_risk_factor_saved = this.state.currentPregnancyData?.pregnancy_risk_factor.split(',');
						let pregnancy_risk_factor_selected = [];
						for (var i = 0; i < pregnancy_risk_factor_saved.length; i++) {
							pregnancy_risk_factor_selected.push(parseInt(pregnancy_risk_factor_saved[i]));
						}
						await this.setState({
							pregnancy_risk_factor : pregnancy_risk_factor_selected,
							pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
						});
						await this.ancFormRef.current.setFieldsValue({
							pregnancy_risk_factor : pregnancy_risk_factor_selected,
							pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
						});
					}

					await this.setState({
			            pregnancy_risk_factor_management_remarks : this.state.currentPregnancyData?.pregnancy_risk_factor_management_remarks || null,
          			});

					await this.ancFormRef.current.setFieldsValue({
						pregnancy_risk_factor_management_remarks : this.state.currentPregnancyData?.pregnancy_risk_factor_management_remarks || null,
					});
				}     
			}
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to fetch the data',
	        placement: 'topRight'
	      })
	    })
  	}

  	getPatientAncDetails = async () => {
	    let Params = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      reference_type: 0,
	      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      source: 'OP',
	    }
	    await Axios.post(Get_Anc_Details,Params).then(async res => {
			if(res.data.status == true)
			{
				let anc_details_data = res.data?.data;
		        if(anc_details_data)
		        {

		        	var totalvaccine_data = [];
		        	let saved_vaccine_data = (anc_details_data.vaccine_data != null && anc_details_data.vaccine_data != "") ? JSON.parse(anc_details_data.vaccine_data) : [];
		        	if(saved_vaccine_data.length > 0)
		        	{
		        		saved_vaccine_data.forEach(ele => {
							let obj = {
								active: ele.active,
								anc: ele.anc,
								name: ele.name,
								noOfDoses: ele.noOfDoses,
								type: ele.type,
								vaccinationId: ele.vaccinationId,
								// vaccine_list: ele.vaccine_list,
								vaccine_status : ele.vaccine_status,
								vaccine_date : ele.vaccine_date != null ? moment(ele.vaccine_date).format('YYYY-MM-DD') : null
							}
							totalvaccine_data.push(obj);
				        });
		        	}
		        	else
		        	{
		        		await this.getVaccineData();
		        	}
					await this.setState({
						immuno_remarks : anc_details_data?.immuno_remarks || null,
						pregnancy_year : anc_details_data?.pregnancy_year || null,
						delivery_mode : anc_details_data?.delivery_mode || null,
						pregnancy_type : anc_details_data?.pregnancy_type || null,
						delivery_indication_for_c_section : anc_details_data?.delivery_indication_for_c_section || null,
						delivery_details : anc_details_data?.delivery_details || null,
						vaccineData : totalvaccine_data
					});

					await this.ancFormRef.current.setFieldsValue({
						immuno_remarks : anc_details_data?.immuno_remarks || null,
						pregnancy_year : anc_details_data?.pregnancy_year || null,
						delivery_mode : anc_details_data?.delivery_mode || null,
						pregnancy_type : anc_details_data?.pregnancy_type || null,
						delivery_indication_for_c_section : anc_details_data?.delivery_indication_for_c_section || null,
						delivery_details : anc_details_data?.delivery_details || null,
						vaccineData : totalvaccine_data
					});
		        }

		        if(anc_details_data?.pregnancy_type == '2')
		        {
		        	let saved_multiple_pregnancies = [];
		        	if(anc_details_data?.multiple_pregnancies.length > 0)
		        	{
		        		anc_details_data?.multiple_pregnancies.forEach(ele => {
			              let obj = { delivery_type : ele.delivery_type, delivery_place : ele.delivery_place, delivery_outcome : ele.delivery_outcome, delivery_bith_date_time : ele.delivery_bith_date_time != null ? moment(ele.delivery_bith_date_time) : null, delivery_gender : ele.delivery_gender, delivery_birth_weight : ele.delivery_birth_weight, delivery_birth_height : ele.delivery_birth_height, delivery_birth_head_cc : ele.delivery_birth_head_cc, delivery_congenital_abnormality : ele.delivery_congenital_abnormality == "true" ? true : false, delivery_congenital_abnormality_remarks : ele.delivery_congenital_abnormality_remarks }
			              saved_multiple_pregnancies.push(obj);
			            });
		        	}
		        	await this.setState({
			            multiple_pregnancies : saved_multiple_pregnancies
		          	});

		          	await this.ancFormRef.current.setFieldsValue({
			            multiple_pregnancies : saved_multiple_pregnancies
		          	});
		        }
		        else
		        {
		        	await this.setState({
			            delivery_type : anc_details_data?.delivery_type || null,
			            delivery_place : anc_details_data?.delivery_place || null,
			            delivery_outcome : anc_details_data?.delivery_outcome || null,
			            delivery_bith_date_time : (anc_details_data?.delivery_bith_date_time && anc_details_data.delivery_bith_date_time != null) ? moment(anc_details_data.delivery_bith_date_time).format('YYYY-MM-DD HH:mm'): null,
			            delivery_gender : anc_details_data?.delivery_gender || null,
			            delivery_birth_weight : anc_details_data?.delivery_birth_weight || null,
			            delivery_birth_height : anc_details_data?.delivery_birth_height || null,
			            delivery_birth_head_cc : anc_details_data?.delivery_birth_head_cc || null,
			            delivery_congenital_abnormality_remarks : (anc_details_data?.delivery_congenital_abnormality == "true" && (anc_details_data?.delivery_congenital_abnormality_remarks != null && anc_details_data?.delivery_congenital_abnormality_remarks != "")) ? anc_details_data?.delivery_congenital_abnormality_remarks : null,
			            delivery_congenital_abnormality : anc_details_data?.delivery_congenital_abnormality == "true" ? true : false,
			            multiple_pregnancies: [],
		          	});

					await this.ancFormRef.current.setFieldsValue({
						delivery_type : anc_details_data?.delivery_type || null,
			            delivery_place : anc_details_data?.delivery_place || null,
			            delivery_outcome : anc_details_data?.delivery_outcome || null,
			            delivery_bith_date_time : (anc_details_data?.delivery_bith_date_time && anc_details_data.delivery_bith_date_time != null) ? moment(anc_details_data.delivery_bith_date_time) : null,
			            delivery_gender : anc_details_data?.delivery_gender || null,
			            delivery_birth_weight : anc_details_data?.delivery_birth_weight || null,
			            delivery_birth_height : anc_details_data?.delivery_birth_height || null,
			            delivery_birth_head_cc : anc_details_data?.delivery_birth_head_cc || null,
			            delivery_congenital_abnormality_remarks : (anc_details_data?.delivery_congenital_abnormality == "true" && (anc_details_data?.delivery_congenital_abnormality_remarks != null && anc_details_data?.delivery_congenital_abnormality_remarks != "")) ? anc_details_data?.delivery_congenital_abnormality_remarks : null,
			            delivery_congenital_abnormality : anc_details_data?.delivery_congenital_abnormality == "true" ? true : false,
			            multiple_pregnancies: [],
					});
		        }
			}
			else
	        {
	        	await this.getVaccineData();
	        }
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to fetch the data',
	        placement: 'topRight'
	      })
	    })
  	}

  	getPatientAncPreviousDetails = async () => {
	    let Params = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      current_reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      // reference_type: 0,
	      // hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      // source: 'OP',  // Patient Specific Data
	    }
	    await Axios.post(Get_Anc_Previous_Details,Params).then(async res => {
			if(res.data.status == true)
			{
				await this.setState({
					prevAncCardData : res.data.data
				})
			}
			else
			{
				await this.setState({
					prevAncCardData : []
				})
			}
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to fetch the data',
	        placement: 'topRight'
	      })
	    })
  	}

  	getListValue(selectedValue, OptionObj = null) {
        if (selectedValue == 0 || selectedValue === null) {
            return "-";
        } else if (OptionObj) {
            return OptionObj[selectedValue];
        } else {
            return selectedValue;
        }
    }

  	showPhysicalExamFPData() {
        const MotherFetusData = this.state.currentPregnancyData.mother_fetus_data;
        if (this.state.currentPregnancyData.mother_fetus_data.length == 0) {
            return (
                <tr>
                    <td colSpan="6">No data available</td>
                </tr>
            );
        }
        return MotherFetusData.map((data, i) => (
            <tr key={data.id} className={i != 0 ? 'highlight_bg' : ''}>
                <td className="text-center" style={(i + 1) == MotherFetusData.length && (i + 1) == MotherFetusData.length ? { paddingBottom: '20px' } : {}}>{i + 1}</td>
                <td className="text-center">{this?.getListValue(data.fetal_movement, FETAL_MOVEMENT)}</td>
                <td className="text-center">{data.fetal_heart_rate || '-'}</td>
                <td className="text-center">{this?.getListValue(data.presentation, PRESENTATION)}</td>
                <td className="text-center">{this?.getListValue(data.relationship_of_pp_to_brim, RELATIONSHIP_TO_PP_BRIM)}</td>
                <td className="text-center">{data.head_cc || '-'}</td>
                <td className="text-center">{data.abdominal_cc || '-'}</td>
                <td className="text-center">{data.femur_length || '-'}</td>
                {
                	i == 0 
                	?
	                    <td rowSpan={MotherFetusData.length}>
	                    	{this.state.currentPregnancyData?.mother_parameter_data?.mother_remarks || '-'}
	            		</td>
                    : 
                    null
                }
            </tr>
        ));
    } 

    render() {
    	const { patientInfo } = this.state;
    	const { ss_configuration, consult_type, prevAncCardData } = this.state;
        return (
            <>
                <AsideLeft />
                <MyHcSpeechRecognition />
                <div className="content-wrapper">
                    <div className="container-fluid emrfrm anc-container mb-4 ">
                        <div className='row'>
                            <div className='col-12 mb-3'>
                                <div className="float-left">
                                    <h1 className="page-title mb-0">ANC Card</h1>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='card anc-cardgrey'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <span className='heading'>Patient Name :&nbsp;</span>
                                            {(patientInfo) ?
                                                <span className='patient_name'>{patientInfo?.first_name !== undefined ? patientInfo?.first_name : null}&nbsp;{patientInfo?.middle_name !== undefined ? patientInfo?.middle_name : null}&nbsp;{patientInfo?.last_name !== undefined ? patientInfo?.last_name : null}, {patientInfo?.dob && patientInfo?.age !== null ? this.getPatientAge(patientInfo?.dob) : null}, {patientInfo?.gender !== undefined && patientInfo?.gender !== null ? (patientInfo?.gender == 'Male' ? ' (M)' : ' (F)') : null}</span>
                                                : null}
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <span className='heading'>Address :&nbsp;</span>
                                            {(patientInfo) ?
                                                <span className='patient_name'>{patientInfo?.address_1 !== undefined ? patientInfo?.address_1 : null}, {patientInfo?.city !== undefined ? patientInfo?.city : null},   {patientInfo?.state !== undefined ? patientInfo?.state : null}</span>
                                                : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                        	prevAncCardData.length > 0  
                        	?
                            	prevAncCardData.map((obj, index) => {
	                                return (
	                                    <AncCardView
                                            ref={this.createRef}
                                            patientInfo={patientInfo}
                                            AncCardData={obj}
                                            index={index}
                                            riskFactorsOptions={this.state.risk_factors_options}
                                        />
	                                );
                            	})
                            : 
                            null
                        }

                        { 
                        	this.state?.currentPregnancyData?.pregnant == "1" 
                        	?
                            <>
                            	<div className='row mt-3'>
                                    <div className='col-12'>
                                        <div className='card anc-carddarkgrey'>
                                            <span className='newancdet'>New ANC Card Details</span>
                                        </div>
                                    </div>
                                </div>
                                <Form
                                    layout="vertical"
                                    className="emrfrm"
                                    ref={this.ancFormRef}
                                    onFinish={this.onFinishAncForm}
                                    id="saveform"
                                >
                                	<div className="row mt-4">
                                        <div className="col-12">
                                            <div className={`form-label-group input-group ${this.state.pregnancy_risk_factor ? "hasdata" : ""}`}>
                                                <Select
						                            showSearch
						                            mode="multiple"
						                            value={this.state.pregnancy_risk_factor_selected}
						                            notFoundContent={null}
						                            filterOption={true}
						                            disabled={!this.state.allowEdit}
						                            onChange={this.handleOnPregnancyRiskFactorChange}
						                            style={{ width: '100%' }}
						                            optionFilterProp="children"
						                          >
						                            {this.optionRiskFactorsLoad()}
					                          	</Select>
                                                <label htmlFor="schedules">Risk Factors</label>
                                            </div>
                                        </div>

                                        <div className="col-12 mt-4">
                                            <div className="form-group">
                                                <div className={`form-group antInputItem micwrap hasdata`}>
                                                    <Link
                                                        onClick={(e) => {
                                                            e.preventDefault(); this.initSpeech({ identifier: "pregnancy_risk_factor_management_remarks" });
                                                        }}
                                                        className={
                                                            this.state.speech.identifier === "pregnancy_risk_factor_management_remarks" &&
                                                                this.state.speech.state
                                                                ? "mic subjective-mic on mute"
                                                                : "mic subjective-mic"
                                                        }
                                                    ></Link>
                                                    <Form.Item name="pregnancy_risk_factor_management_remarks" label="Risk Factors Remarks" id="pregnancy_risk_factor_management_remarks" 
                                                        onInput={(e) => this.autoHeight(e)}
                                                    >
                                                        <textarea style={{ height:"100px", maxHeight: "100px", overflow:"auto" }} className="form-control diagnosis_notes_class speech-field"
                                                        	name="pregnancy_risk_factor_management_remarks"
                                                        	onChange={this.handleOnTextChange}
                          									value={this.state.pregnancy_risk_factor_management_remarks}
                          									disabled={!this.state.allowEdit}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row mt-2'>
                                        <div className='col-12'>
                                            <span className='title'> Allergies</span>
                                        </div>
                                        <table className="table table-bordered mt-3" >
                                            <thead>
                                                <tr>
                                                    <td width="28%">ALLERGY NAME</td>
                                                    <td width="22%">REACTION</td>
                                                    <td width="15%">DURATION</td>
                                                    <td width="15%">INTENSITY</td>
                                                    <td width="15%">INFORMED BY</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.current_allergies != undefined && this.state.current_allergies.length > 0 ?
                                                    this.state.current_allergies.map((obj) => (
                                                        <tr>
                                                            <td>{obj.allergy_name}</td>
                                                            <td>{obj.reaction ? obj.reaction : '-'}</td>
                                                            <td>{obj.duration ? obj.duration + ' ' + DURATION_TYPE[obj.durationType] : '-'}</td>
                                                            <td>{obj.intensity === 0 ? "Low" : obj.intensity === 1 ? "Medium" : obj.intensity === 2 ? "High" : '-'}</td>
                                                            <td>{obj?.informedBy == 0 || obj?.informedBy == 1 ? INFORMED_BY[obj?.informedBy] : "-"}</td>
                                                        </tr>
                                                    ))
                                                    : <tr><td colspan="5">No data available</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='row mt-4'>
                                        <div className='col-12'>
                                            <span className='title'>Existing Condition</span>
                                        </div>
                                        <table className="table table-bordered mt-3" >
                                            <thead>
                                                <tr>
                                                    <td width="30%">CONDITIONS</td>
                                                    <td width="20%">DURATION</td>
                                                    <td width="20%">ON MEDICATION</td>
                                                    <td width="30%">MEDICINE NAME</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.current_conditions != undefined && this.state.current_conditions.length > 0 ?
                                                    this.state.current_conditions.map((c, i) => (
                                                        <tr>
                                                            <td>{c.condition_description}</td>
                                                            <td>{(c.duration) ? `${c.duration} ${DURATION_TYPE[c.durationType]}` : '-'}</td>
                                                            <td>{MEDICATION_ON[c.onMedication] ? MEDICATION_ON[c.onMedication] : '-'}</td>
                                                            <td>{c.medicineName || "NA"}</td>
                                                        </tr>
                                                    ))
                                                    : <tr><td colspan="4">No data available</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                    {
                                    	this.state.currentPregnancyData?.menstural_data 
                                    	?
	                                        <>
	                                            <div className='row mt-4'>
	                                                <div className='col-3'>
	                                                    <span className='title'>Menstrual Hx</span>
	                                                </div>
	                                                <div className='col-2'>
	                                                    <span>LMP:</span>
	                                                    <span className='title'>
	                                                    	{(this.state.currentPregnancyData?.menstural_data?.lmp && this.state.currentPregnancyData?.menstural_data.lmp != null) ? moment(this.state.currentPregnancyData?.menstural_data.lmp).format('YYYY-MM-DD'): '-'}
                                                    	</span>
	                                                </div>
	                                                <div className='col-2'>
	                                                    {
	                                                    	(this.state.currentPregnancyData?.menstural_data?.cycle_length != null && this.state.currentPregnancyData?.menstural_data?.cycle_length != "")
	                                                    	?
		                                                        <>
		                                                            <span>Cycle Length:</span>
		                                                            <span className='title'>
		                                                            	{this.state.currentPregnancyData?.menstural_data?.cycle_length + " days"}
	                                                            	</span>
		                                                        </>
	                                                        : 
	                                                        null
	                                                    }
	                                                </div>
	                                                <div className='col-5 text-right'>
	                                                    <span className='title'>Last Updated
                                                        ({moment(this.state.currentPregnancyData?.menstural_data?.updatedAt).format("D MMM, YYYY | h:mm A")}
                                                        )</span>
	                                                </div>
	                                            </div>
	                                        </>
                                        : 
                                        null
                                    }
                                    {
                                    	this.state.currentPregnancyData ?
                                        <>
                                            <div className='row mt-4 d-flex align-items-center'>
                                                <div className='col-2'>
                                                    <span className='title'>Obstetric Hx</span>
                                                </div>
                                                {this.state.currentPregnancyData?.edd_by_lmp ?
                                                    <div className='col-3'>
                                                        <span>EDD by LMP:</span><span className='title'> {this.state.currentPregnancyData?.edd_by_lmp ? moment(this.state.currentPregnancyData?.edd_by_lmp).format("D MMM, YYYY") : '-'}</span>
                                                    </div>
                                                    : null}
                                                {this.state.currentPregnancyData?.corrected_edd != null && this.state.currentPregnancyData?.corrected_edd != "" && this.state.currentPregnancyData?.corrected_edd != undefined ?
                                                    <div className='col-auto'>
                                                        <div className='card obs_card'>
                                                            <div className='row'>
                                                                <div className='col-12'>
                                                                    <span className='title_red'>Corrected EDD:</span><span >{moment(this.state.currentPregnancyData?.corrected_edd).format("D MMM, YYYY")}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null
                                                }
                                                {
                                                	this.state?.currentPregnancyData?.lactating 
                                                	?
	                                                    <div className='col-2 text-right'>
	                                                        <span className='title'>Lactating</span>
	                                                    </div>
                                                    : 
                                                    null
                                                }
                                                {
                                                	this.state?.currentPregnancyData?.obstetric_data 
                                                	?
	                                                    <div className='col-2 text-right'>
	                                                        <span className='title'>
	                                                        	<span className="bg-grey  py-1 px-3 rounded font-weight-bold">
														            {(this.state?.currentPregnancyData?.obstetric_data.gravidity != null && this.state?.currentPregnancyData?.obstetric_data.gravidity !== '') ? 'G'+this.state?.currentPregnancyData?.obstetric_data.gravidity+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.parity != null && this.state?.currentPregnancyData?.obstetric_data.parity !== '') ? 'P'+this.state?.currentPregnancyData?.obstetric_data.parity+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.abortion != null && this.state?.currentPregnancyData?.obstetric_data.abortion !== '') ? 'A'+this.state?.currentPregnancyData?.obstetric_data.abortion+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.live_birth != null && this.state?.currentPregnancyData?.obstetric_data.live_birth !== '') ? 'L'+this.state?.currentPregnancyData?.obstetric_data.live_birth+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.ectopic != null && this.state?.currentPregnancyData?.obstetric_data.ectopic !== '') ? 'E'+this.state?.currentPregnancyData?.obstetric_data.ectopic+' ' : ''}
													          	</span>
	                                                        </span>
	                                                    </div>
                                                    : 
                                                    null
                                                }
                                            </div>
                                            {
                                            	this.state.currentPregnancyData?.obstetric_remarks && this.state.currentPregnancyData?.obstetric_remarks != "" && this.state.currentPregnancyData?.obstetric_remarks != null 
                                            	?
		                                            <div className='row mt-4'>
		                                                <div className='col-2'>
		                                                    <span className='title'>Obstetric Remarks</span>
		                                                </div>
		                                                <div className='col-10'>
		                                                    <pre style={{ fontSize: "15px", border: "none" }}>{this.state.currentPregnancyData.obstetric_remarks}</pre> 
		                                                </div>
		                                            </div>
                                            	: 
                                            	null
                                            }
                                        </>
                                        : 
                                        null
                                    }
                                    {
                                    	this.state.currentPregnancyData.mother_parameter_data || (this.state.currentPregnancyData.mother_fetus_data && this.state.currentPregnancyData.mother_fetus_data.length > 0) 
                                    	?
	                                        <>
	                                            <div className='row mt-4'>
	                                                <div className='col-12'>
	                                                    <span className='title'> Physical Examination</span>
	                                                </div>
	                                            </div>
	                                            {
	                                            	this.state.currentPregnancyData.mother_parameter_data ?
	                                                <>
	                                                    <div className='row mt-3 '>
	                                                        <div className='col-4'>
	                                                            <span className='title'>Mother's Parameters</span>
	                                                        </div>
	                                                        <div className='col-8 text-right'>
	                                                            <span className='title'>
	                                                            	Last Updated ({moment(this.state.currentPregnancyData.mother_parameter_data.updatedAt).format("D MMM, YYYY | h:mm A")})
	                                                            </span>
	                                                        </div>
	                                                        <table className="table table-bordered mt-3" >
	                                                            <thead>
	                                                                <tr>
	                                                                    <td width="10%">POG (WEEKS)</td>
	                                                                    <td width="10%">WEIGHT (KG)</td>
	                                                                    <td width="10%">BP (MMHG)</td>
	                                                                    <td width="10%">PULSE RATE (MIN)</td>
	                                                                    <td width="10%">FUNDAL HT (CM)</td>
	                                                                    <td width="10%">EDEMA</td>
	                                                                    <td width="10%">PALLOR</td>
	                                                                    <td width="10%">CERVIX EXAM</td>
	                                                                    <td width="10%">PRETERM LABOUR (SIGN/SYMPTOMS)</td>
	                                                                </tr>
	                                                            </thead>
	                                                            <tbody>
	                                                            	<tr>
													                    <td>{this.state.currentPregnancyData.mother_parameter_data.pog || '-'}</td>
													                    <td>{this.state.currentPregnancyData.mother_parameter_data.weight || '-'}</td>
													                    <td>{this.state.currentPregnancyData.mother_parameter_data.blood_pressure || '-'}</td>
													                    <td>{this.state.currentPregnancyData.mother_parameter_data.pulse_rate || '-'}</td>
													                    <td>{this.state.currentPregnancyData.mother_parameter_data.fundal_height || '-'}</td>
													                    <td>{this.state.currentPregnancyData.mother_parameter_data.edema || '-'}</td>
													                    <td>{this.state.currentPregnancyData.mother_parameter_data.pallor || '-'}</td>
													                    <td>{this.state.currentPregnancyData.mother_parameter_data.cervix_exam || '-'}</td>
													                    <td>{this.state.currentPregnancyData.mother_parameter_data.preterm_labour || '-'}</td>
													                </tr>
	                                                            </tbody>
	                                                        </table>
	                                                    </div>
	                                                </>
	                                                : 
	                                                null
	                                            }
	                                            <div className='row mt-4 '>
	                                                <div className='col-4'>
	                                                    <span className='title'>Fetal Parameters</span>
	                                                </div>
	                                                {
	                                                	(this.state.currentPregnancyData.mother_fetus_data && this.state.currentPregnancyData.mother_fetus_data.length > 0) 
	                                                	?
		                                                    <div className='col-8 text-right'>
		                                                        <span className='title'>Last Updated
		                                                            ({this.state.currentPregnancyData.mother_fetus_data?.map((data, index) => (index == 0 ? moment(data.createdAt).format("D MMM, YYYY | h:mm A") : ''))})
		                                                        </span>
		                                                    </div>
	                                                    : null
	                                                }
	                                                <table className="table table-bordered mt-3" >
	                                                    <thead>
	                                                        <tr>
	                                                            <td width="10%">FETUS NO.</td>
	                                                            <td width="10%">FETAL MOVEMENT</td>
	                                                            <td width="10%">FHR(B/Min)</td>
	                                                            <td width="10%">PRESENTATION</td>
	                                                            <td width="10%">RELATION OF PP TO BRIM</td>
	                                                            <td width="10%">HEAD CC (CM)</td>
	                                                            <td width="10%">ABDOMINAL CC (CM)</td>
	                                                            <td width="10%">FEMUR LENGTH(CM)</td>
	                                                            <td width="10%">REMARKS</td>
	                                                        </tr>
	                                                    </thead>
	                                                    <tbody>
	                                                        {this.showPhysicalExamFPData()}
	                                                    </tbody>
	                                                </table>
	                                            </div>
	                                        </>
                                        : 
                                        null
                                    }
                                    {
                                    	(this.state.vaccineData && this.state.vaccineData.length > 0) 
                                    	?
                                    		<>
                                    			<div className='row mt-4 '>
				                                    <div className='col-12'>
				                                        <span className='title'>Immunoprophylaxis</span>
				                                    </div>
				                                </div>
				                                <div className='row mt-3'>
									          		<Form.List name="vaccine_data">
									            		{() => (
									              			this.state.vaccineData.map((data, key) => (
									              				<>
									              					<div className='col-2 mb-4'>
			                                                    		<div className='row'>
			                                                        		<div className='ml-2'>
																				<Form.Item
																					name={[key, 'vaccine_status']}
																					className='float-right mr-0'
																				>
																					<Checkbox
																	                    name={[key, 'vaccine_status']}
																	                    checked={data?.vaccine_status === "true"}
																	                    defaultChecked={data?.vaccine_status === "true"}
																	                    disabled={!this.state.allowEdit}
																	                    onChange={(e) => this.onCheckVaccine(e, key,'vaccine_status')}
																                  	>
																                  	{data.name}
					                                                                </Checkbox>
																				</Form.Item>
																			</div>
																			<div className="col-12">
					                                                            <Form.Item
					                                                                name={[key, 'vaccine_date']}
					                                                                className='mb-0'
					                                                                rules={[
					                                                                    {
															                                required: data.vaccine_status == true,
															                                message: "Date is Required",
															                            },
					                                                                ]}
					                                                            >
					                                                                <DatePicker
					                                                                    format="DD MMM, YYYY"
					                                                                    name={[key, 'vaccine_date']}
					                                                                    disabled={!this.state.allowEdit}
					                                                                    disabledDate={this.disabledPastDate}
					                                                                    value={data?.vaccine_date ? moment(data.vaccine_date) : null}
					                                                                    defaultValue={data?.vaccine_date ? moment(data.vaccine_date) : null}
					                                                                    onChange={(date, dateString) => this.handleVaccineDate(date, dateString, key, 'vaccine_date')}
					                                                                    className='mb-0'
					                                                                    style={{
					                                                                        width: 100 + "%",
					                                                                        height: 30 + "px",

					                                                                    }}
					                                                                />
					                                                            </Form.Item>
					                                                        </div>
																		</div>
																	</div>
																</>
								                            ))
											            )}
										          	</Form.List>
										        </div>
									        </>
								        :
								        null
							        }
			                        <div className='row mt-4 '>
                                        <div className='col-12'>
                                            <span className='title'>Delivery Details</span>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-4'>
                                            <div className="antSelectItem hasdata">
                                                <Form.Item
                                                    label="Year"
                                                    name="pregnancy_year"
                                                    className="margin-prev"
                                                    rules={[
                                                        {
                                                            required: this.state.pregnancy_type || this.state.delivery_mode,
                                                            message: "Select Pregnancy Year",
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        showSearch
                                                        name="pregnancy_year"
                                                        id="pregnancy_year"
                                                        value={this.state.pregnancy_year}
                                                        optionFilterProp="children"
                                                        disabled={!this.state.allowEdit}
                                                        filterOption={(input, option) => {
                                                            return option.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                                                        }}

                                                        onChange={(val, props) => this.onSelectChangeList(val, props, 'pregnancy_year')}
                                                    >
                                                        {this.state.year_options !== undefined && this.state.year_options.length > 0 ? this.state.year_options.map((d, i) => (
                                                            <Option key={i} value={d} label={d}>{d}</Option>
                                                        )) : null}

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='col-4'>
                                            <div className="antSelectItem hasdata">
                                                <Form.Item
                                                    label="Mode"
                                                    name="delivery_mode"
                                                    rules={[
                                                        {
                                                            required: this.state.pregnancy_type || this.state.pregnancy_year,
                                                            message: "Select Mode",
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        style={{ width: '100%' }}
                                                        name="delivery_mode"
                                                        disabled={!this.state.allowEdit}
                                                        value={this.state.delivery_mode}
                                                        onChange={(val, props) => this.onSelectChangeList(val, props, 'delivery_mode')}
                                                    >
                                                        <Option value="1">
                                                            Natural
                                                        </Option>
                                                        <Option value="2">
                                                            IVF
                                                        </Option>
                                                        <Option value="3">
                                                            IUI
                                                        </Option>
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='col-4'>
                                            <div className="antSelectItem hasdata">
                                                <Form.Item
                                                    label="Pregnancy Type"
                                                    name="pregnancy_type"
                                                    className="margin-prev"
                                                    rules={[
                                                        {
                                                            required: this.state.delivery_mode || this.state.pregnancy_year,
                                                            message: "Select Pregnancy Type",
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        style={{ width: 100 + '%' }}
                                                        showSearch
                                                        name="pregnancy_type"
                                                        id="pregnancy_type"
                                                        disabled={!this.state.allowEdit}
                                                        optionFilterProp="children"
                                                        value={this.state.pregnancy_type}
                                                        filterOption={(input, option) => {
                                                            return option.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                                                        }}
                                                        onChange={(val, props) => this.onSelectChangeList(val, props, 'pregnancy_type')}
                                                    >
                                                        {this.state.pregnancy_options !== undefined && this.state.pregnancy_options.length > 0 ? this.state.pregnancy_options.map((d, i) => (
                                                            <Option key={i} value={d.val} label={d.label}>{d.label}</Option>
                                                        )) : null}

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                            <label class="text-secondary text-underline cursor-pointer" style={{ display: this.state?.multiple_pregnancies?.length ? 'block' : 'none' }}>
                                                <button type="button" class="ant-btn nostyle-link text-secondary text-underline float-right pt-1 pr-1" onClick={() => this.setState({ multiplePregnanciesModal: true })}>
                                                    <span>Multiple({this.state?.multiple_pregnancies?.length})</span>
                                                </button>
                                            </label>
                                        </div>
                                    </div>
                                    {
                                    	this.state.pregnancy_type != '2' && this.state.pregnancy_type != null
                                    	?
	                                        <>
	                                            <div className='row mt-3'>
	                                            	<div className="col-3">
	                                                    <div className="antSelectItem hasdata">
	                                                        <Form.Item
	                                                            label="Delivery"
	                                                            name="delivery_type"
	                                                            rules={[
	                                                                {
	                                                                    required: this.state.outcome == "1" || this.state.outcome == "2",
	                                                                    message: "Select Delivery Type",
	                                                                },
	                                                            ]}
	                                                        >
	                                                            <Select
	                                                                style={{ width: 100 + '%' }}
	                                                                showSearch
	                                                                name="delivery_type"
	                                                                id="delivery_type"
	                                                                disabled={!this.state.allowEdit}
	                                                                value={this.state.delivery_type}
	                                                                optionFilterProp="children"
	                                                                filterOption={(input, option) => {
	                                                                    return option.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
	                                                                }}
	                                                                onChange={(val, props) => this.onSelectChangeList(val, props, 'delivery_type')}
	                                                            >
	                                                                {this.state.delivery_options !== undefined && this.state.delivery_options.length > 0 ? this.state.delivery_options.map((d, i) => (
	                                                                    <Option key={i} value={d.val} label={d.label}>{d.label}</Option>
	                                                                )) : null}

	                                                            </Select>
	                                                        </Form.Item>
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className="antSelectItem hasdata">
	                                                        <Form.Item
	                                                            label="Place"
	                                                            name="delivery_place"
	                                                            value={this.state.delivery_place}
	                                                            rules={[
	                                                                {
	                                                                    required: this.state.delivery_outcome == "1" || this.state.delivery_outcome == "2",
	                                                                    message: "Select Place",
	                                                                },
	                                                            ]}
	                                                        >
	                                                            <Select
	                                                                style={{ width: '100%' }}
	                                                                disabled={!this.state.allowEdit}
	                                                                name="delivery_place"
	                                                                onChange={(val, props) => this.onSelectChangeList(val, props, 'delivery_place')}
	                                                            >
	                                                                <Option value="1">
	                                                                    Hospital
	                                                                </Option>
	                                                                <Option value="2">
	                                                                    Home
	                                                                </Option>
	                                                                <Option value="3">
	                                                                    PHC
	                                                                </Option>
	                                                                <Option value="4">
	                                                                    Others
	                                                                </Option>
	                                                            </Select>
	                                                        </Form.Item>
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className="antSelectItem hasdata">
	                                                        <Form.Item
	                                                            label="Outcome"
	                                                            name="delivery_outcome"
	                                                            rules={[
	                                                                {
	                                                                    required: true,
	                                                                    message: "Select Outcome",
	                                                                },
	                                                            ]}
	                                                        >
	                                                            <Select
	                                                                style={{ width: '100%' }}
	                                                                name="delivery_outcome"
	                                                                disabled={!this.state.allowEdit}
	                                                                value={this.state.delivery_outcome}
	                                                                onChange={(val, props) => this.onSelectChangeList(val, props, 'delivery_outcome')}
	                                                            >
	                                                                <Option value="1">
	                                                                    Live Term
	                                                                </Option>
	                                                                <Option value="2">
	                                                                    Live Pre-Term
	                                                                </Option>
	                                                                <Option value="3">
	                                                                    Still born Term
	                                                                </Option>
	                                                                <Option value="4">
	                                                                    Still born Pre-Term
	                                                                </Option>
	                                                                <Option value="5">
	                                                                    Spontaneous Abortion
	                                                                </Option>
	                                                                <Option value="6">
	                                                                    MTP
	                                                                </Option>

	                                                            </Select>
	                                                        </Form.Item>
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className="antSelectItem hasdata">
	                                                        <Form.Item
	                                                            name="delivery_bith_date_time"
	                                                            className='mb-0'
	                                                            label="Birth Date & Time"
	                                                            rules={[
	                                                                {
	                                                                    required: this.state.delivery_outcome == "1" || this.state.delivery_outcome == "2",
	                                                                    message: "Birth Date & Time is Required",
	                                                                },
	                                                            ]}
	                                                        >
	                                                            <DatePicker showTime
	                                                                name="delivery_bith_date_time"
	                                                                format="DD MMM, YYYY HH:mm"
	                                                                disabledDate={this.disabledPastDate}
	                                                                disabled={!this.state.allowEdit}
	                                                                value={this.state.delivery_bith_date_time}
	                                                                defaultValue={this.state.delivery_bith_date_time}
	                                                                placeholder=''
	                                                                className='mb-0'
	                                                                style={{
	                                                                    width: 100 + "%",
	                                                                    height: 41 + "px",
	                                                                }}
	                                                                onChange={(val, props) => this.onSelectChangeList(val, props, 'delivery_bith_date_time')}
	                                                            />
	                                                        </Form.Item>
	                                                    </div>
	                                                </div>
	                                            </div>
	                                            <div className='row mt-3'>
	                                                <div className="col-3">
	                                                    <div className="antSelectItem hasdata">
	                                                        <Form.Item
	                                                            label="Gender"
	                                                            name="delivery_gender"
	                                                            rules={[
	                                                                {
	                                                                    required: this.state.delivery_outcome == "1" || this.state.delivery_outcome == "2",
	                                                                    message: "Select Gender",
	                                                                },
	                                                            ]}
	                                                        >
	                                                            <Select
	                                                                style={{ width: 100 + '%' }}
	                                                                showSearch
	                                                                name="delivery_gender"
	                                                                id="delivery_gender"
	                                                                optionFilterProp="children"
	                                                                disabled={!this.state.allowEdit}
	                                                                value={this.state.delivery_gender} 
	                                                                filterOption={(input, option) => {
	                                                                    return option.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
	                                                                }}
	                                                                onChange={(val, props) => this.onSelectChangeList(val, props, 'delivery_gender')}
	                                                            >
	                                                                {this.state.gender_options !== undefined && this.state.gender_options.length > 0 ? this.state.gender_options.map((d, i) => (
	                                                                    <Option key={i} value={d.val} label={d.label}>{d.label}</Option>
	                                                                )) : null}

	                                                            </Select>
	                                                        </Form.Item>
	                                                    </div>
	                                                </div>
	                                                <div className="col-3">
	                                                    <div className="form-group">
	                                                        <div className="antSelectItem hasdata">
	                                                            <Form.Item name="delivery_birth_weight" label="Birth Weight (kg)" id="delivery_birth_weight"
	                                                                rules={[
	                                                                    {
	                                                                        required: this.state.delivery_outcome == "1" || this.state.delivery_outcome == "2",
	                                                                        message: "Birth Weight is Required",
	                                                                    },
	                                                                    {
	                                                                        validator: this.validateNumber,
	                                                                        transform: this.normalizeValue
	                                                                    }
	                                                                ]}
	                                                            >
	                                                                <Input className=""
	                                                                    onChange={this.handleOnTextChange}
	                                                                    name="delivery_birth_weight"
	                                                                    disabled={!this.state.allowEdit}
	                                                                    type='number'
	                                                                    value={this.state.delivery_birth_weight} 
	                                                                />
	                                                            </Form.Item>
	                                                        </div>
	                                                    </div>
	                                                </div>
	                                                <div className="col-3">
	                                                    <div className="form-group">
	                                                        <div className="antSelectItem hasdata">
	                                                            <Form.Item name="delivery_birth_height" label="Birth Height (cm)" id="delivery_birth_height"
	                                                                rules={[
	                                                                    {
	                                                                        required: this.state.delivery_outcome == "1" || this.state.delivery_outcome == "2",
	                                                                        message: "Birth Height is Required",
	                                                                    },
	                                                                    {
	                                                                        validator: this.validateNumber,
	                                                                        transform: this.normalizeValue
	                                                                    }
	                                                                ]}
	                                                            >
	                                                                <Input className=""
	                                                                    onChange={this.handleOnTextChange}
	                                                                    name="delivery_birth_height"
	                                                                    disabled={!this.state.allowEdit}
	                                                                    type='number'
	                                                                    value={this.state.delivery_birth_height} 
	                                                                />
	                                                            </Form.Item>
	                                                        </div>
	                                                    </div>
	                                                </div>
	                                                <div className="col-3">
	                                                    <div className="form-group">
	                                                        <div className="antSelectItem hasdata">
	                                                            <Form.Item name="delivery_birth_head_cc" label="Birth Head CC (cm)" id="delivery_birth_head_cc"
	                                                                rules={[
	                                                                    {
	                                                                        required: this.state.delivery_outcome == "1" || this.state.delivery_outcome == "2",
	                                                                        message: "Birth Head CC is Required",
	                                                                    },
	                                                                    {
	                                                                        validator: this.validateNumber,
	                                                                        transform: this.normalizeValue
	                                                                    }
	                                                                ]}
	                                                            >
	                                                                <Input className=""
	                                                                    onChange={this.handleOnTextChange}
	                                                                    name="delivery_birth_head_cc"
	                                                                    type='number'
	                                                                    disabled={!this.state.allowEdit}
	                                                                    value={this.state.delivery_birth_head_cc} 
	                                                                />
	                                                            </Form.Item>
	                                                        </div>
	                                                    </div>
	                                                </div>
	                                            </div>
	                                            <div className='row mt-3'>
	                                                <div className="col-3">
	                                                    <div className="form-group">
	                                                        <div className="antSelectItem hasdata">
	                                                            <Form.Item
	                                                                name="delivery_congenital_abnormality"
	                                                                valuePropName="checked"
	                                                            >
	                                                                <Checkbox
													                    name="delivery_congenital_abnormality"
													                    disabled={!this.state.allowEdit}
													                    checked={this.state.delivery_congenital_abnormality === true}
													                    onChange={e => this.onSelectCheckChangeListMultiple(e)}
												                  	>
	                                                                    Congenital Abnormality
	                                                                </Checkbox>
	                                                            </Form.Item>
	                                                        </div>
	                                                    </div>
	                                                </div>
	                                                {
	                                                	this.state.delivery_congenital_abnormality == true 
	                                                	?
		                                                    <div className="col-9">
		                                                        <div className="form-group">
		                                                            <div className='antInputItem micwrap hasdata' >
		                                                            	<Link
					                                                        onClick={(e) => {
					                                                            e.preventDefault(); this.initSpeech({ identifier: "delivery_congenital_abnormality_remarks" });
					                                                        }}
					                                                        className={
					                                                            this.state.speech.identifier === "delivery_congenital_abnormality_remarks" &&
					                                                                this.state.speech.state
					                                                                ? 'mic r-0 on mute' : 'mic r-0'
			                                                        		}
			                                                        	></Link>
		                                                                <Form.Item
		                                                                    name="delivery_congenital_abnormality_remarks" 
		                                                                    label="Congenital Abnormality Remark"
		                                                                    rules={[
		                                                                        {
		                                                                            required: true,
		                                                                            message: "Congenital Abnormality Remark Required",
		                                                                        },
		                                                                    ]}
		                                                                >
		                                                                    <textarea className="form-control diagnosis_notes_class speech-field" value={this.state.delivery_congenital_abnormality_remarks}
						                                                        name="delivery_congenital_abnormality_remarks"
						                                                        onChange={this.handleOnTextChange}
						                                                        disabled={!this.state.allowEdit}
						                                                    />
		                                                                </Form.Item>
		                                                            </div>
		                                                        </div>
		                                                    </div>
	                                                    : 
	                                                    null
	                                                }
	                                            </div>
	                                        </>
                                        : 
                                        null
                                    }
                                    <div className='row mt-3'>
                                        <div className="col-6">
                                            <div className="form-group">
                                                <div className={`form-group antInputItem micwrap hasdata`}>
                                                    <Link
                                                        onClick={(e) => {
                                                            e.preventDefault(); this.initSpeech({ identifier: "delivery_indication_for_c_section" });
                                                        }}
                                                        className={
                                                            this.state.speech.identifier === "delivery_indication_for_c_section" &&
                                                                this.state.speech.state
                                                                ? 'mic r-0 on mute' : 'mic r-0'
                                                        }
                                                    ></Link>
                                                    <Form.Item name="delivery_indication_for_c_section" label="Indication for C-Section" id="delivery_indication_for_c_section"
                                                        onInput={(e) => this.autoHeight(e)}
                                                    >
                                                        <textarea className="form-control diagnosis_notes_class speech-field" value={this.state.delivery_indication_for_c_section}
                                                        name="delivery_indication_for_c_section"
                                                        onChange={this.handleOnTextChange}
                                                        disabled={!this.state.allowEdit}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-6'>
                                            <div className="form-group">
                                                <div className={`form-group antInputItem micwrap hasdata`}>
                                                    <a
                                                        onClick={(e) => {
                                                            e.preventDefault(); this.initSpeech({ identifier: "delivery_details" });
                                                        }}
                                                        className={
                                                            this.state.speech.identifier === "delivery_details" &&
                                                                this.state.speech.state
                                                                ? 'mic r-0 on mute' : 'mic r-0'
                                                        }
                                                    ></a>
                                                    <Form.Item name="delivery_details" label="Details" id="delivery_details"
                                                        onInput={(e) => this.autoHeight(e)}
                                                    >
                                                        <textarea className="form-control diagnosis_notes_class speech-field" value={this.state.delivery_details}
                                                        name="delivery_details"
                                                        onChange={this.handleOnTextChange}
                                                        disabled={!this.state.allowEdit}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mt-4 mb-5'>
                                        <div className='col-12 text-center'>
                                            <Form.Item>
                                                <button onClick={() => this.printAncDetails()} type="button" className="btn btn-primary px-5 mr-3">Print {this.state.isPrintLoader ? LOADER : null}</button>
                                                <button htmlType="submit" className="btn btn-primary px-5 ml-3" disabled={this.state.spin_loading}>SAVE {this.state.spin_loading ? LOADER : null}</button>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </Form>
                            </>
                            :
                            null
                        }
                    </div>
                </div >

                {/* Modal For Multiple Pregnancies */}
                <Modal
                    title="Multiple Pregnancy Details"
                    destroyOnClose={true}
                    visible={this.state.multiplePregnanciesModal}
                    onCancel={(e) =>
                        this.handleModalPopup(e, "multiplePregnanciesModal")
                    }
                    width="1800px"
                    bodyStyle={{ paddingBottom: "15px" }}
                    className="emrfrm"
                    footer={false}
                >
                    {this.state.multiplePregnanciesModal ?
                        <MultiplePregnancies
                            allowEdit={this.state.allowEdit}
                            multiple_pregnancies={this.state.multiple_pregnancies}
                            handleModalSave={this.handleModalSave}
                        />
                        : null}
                </Modal>

                <Modal
                    title="Anc Details"
                    visible={this.state.showRxModal}
                    footer={false}
                    width={850}
                    onCancel={() => { this.setState({ showRxModal: false, rxPdfPath: null }) }}
                    style={{ top: 20 }}
                >
                    <div className="row">
                        <div className="col-12 my-3 text-center">
                            <iframe src={this.state.rxPdfPath} frameBorder="0" scrolling="no" style={{ overflow: 'hidden' }} width="100%" height="700"></iframe>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}
